// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2a1KZ","imageUploader":"EGiftCard_imageUploader__cRUXB"};